export default "__VITE_ASSET__CJPTdVRC__"